export const SCHEMA_VERSION = "05b0e9ef9977389d6f0366350ff3858a";